import { useEffect } from 'react';
import unescapedText from 'I18n/utils/unescapedText';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { gdprCookieConsentPromptMessage } from 'conversations-internal-schema/widget-data/operators/gdprCookieConsentPromptMessage';
import { useChatWidgetLocale } from 'conversations-visitor-experience-components/visitor-widget/ChatWidgetLocaleContext';
import { useAppSelector, useAppDispatch } from '../../buildStore';
import { trackInteraction } from '../../usage-tracking/actions/trackInteraction';
import { EVENT_NAMES } from '../../usage-tracking/constants/eventNames';
import { getIsAIChatbot } from '../../selectors/widgetDataSelectors/getIsAIChatbot';
import { getColoring } from '../../selectors/widgetDataSelectors/getColoring';
import { getUseSpotlightLauncher } from '../../widget-data/selectors/widgetDataSelectors';
import { getIsExitIntentCookiePrompt } from '../../utils/gdprCookieConsentPromptHelpers';
import { getLatestWidgetData } from '../../widget-data/selectors/getLatestWidgetData';
import { consentToCookies } from '../actions/visitorConsentsToCookies';
import { declineCookies } from '../actions/visitorDeclinesCookies';
import { jsx as _jsx } from "react/jsx-runtime";
const useCookieConsentPrompt = () => {
  const locale = useChatWidgetLocale();
  const dispatch = useAppDispatch();
  const isAIChatBot = useAppSelector(getIsAIChatbot);
  const isSpotlight = useAppSelector(getUseSpotlightLauncher);
  const widgetColoring = useAppSelector(getColoring);
  const latestWidgetData = useAppSelector(getLatestWidgetData);
  const cookieConsentPromptMessage = gdprCookieConsentPromptMessage(latestWidgetData);
  const isExitIntentPrompt = useAppSelector(getIsExitIntentCookiePrompt);
  useEffect(() => {
    dispatch(trackInteraction(EVENT_NAMES.WIDGET_INTERACTION, {
      action: 'view consent to cookies'
    }));
  }, [dispatch]);
  const handleConsentToCookies = () => {
    dispatch(consentToCookies());
  };
  const handleDeclineCookies = () => {
    dispatch(declineCookies());
  };
  const pageLoadMessage = cookieConsentPromptMessage || unescapedText('conversations-visitor-ui.gdpr.consentToCookies.pageLoadCookieConsent', {
    locale
  });
  const exitIntentHeaderMessage = cookieConsentPromptMessage ? '' : /*#__PURE__*/_jsx(FormattedMessage, {
    message: "conversations-visitor-ui.gdpr.consentToCookies.promptHeader",
    options: {
      locale
    }
  });
  const exitIntentMessage = cookieConsentPromptMessage || unescapedText('conversations-visitor-ui.gdpr.consentToCookies.exitIntentCookieConsent', {
    locale
  });
  return {
    isAIChatBot,
    isSpotlight,
    widgetColoring,
    isExitIntentPrompt,
    pageLoadMessage,
    exitIntentHeaderMessage,
    exitIntentMessage,
    handleConsentToCookies,
    handleDeclineCookies
  };
};
export default useCookieConsentPrompt;